module.exports = __webpack_public_path__ + "static/media/transfiguration.5e3f872b.webp";